"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetricsFilter_1 = require("./_MetricsFilter");
exports._MetricsConfiguration = {
    type: "structure",
    required: ["Id"],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        Filter: {
            shape: _MetricsFilter_1._MetricsFilter
        }
    }
};
//# sourceMappingURL=_MetricsConfiguration.js.map